import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';
import { PATH_LIVE_INVENTORY } from '../routes/paths';

// The live inventory page is for brokers only. Anybody else who lands here is
// sent to wherever their own role lives, rather than shown a page whose every
// request would come back forbidden.
BrokerGuard.propTypes = {
  children: PropTypes.node,
};

export default function BrokerGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();

  if (!isInitialized) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to={PATH_LIVE_INVENTORY.login} replace />;
  if (user?.role !== 'broker') return <Navigate to="/auth/crossing" replace />;

  return <>{children}</>;
}
